import { API_BASE } from '@/Module/Core/Constant';

export const WORKSPACE_API = {
  GENERAL_STATISTICS: `${API_BASE}/lessons/current-user/general-statistics`,
  VIDEOS_FULL_DATA: `${API_BASE}/lessons/current-user/viewed-videos-full-data`,
  MONTHLY_VIEWED: `${API_BASE}/lessons/current-user/monthly-viewed-videos`,
  WEEKLY_VIEWED: `${API_BASE}/lessons/current-user/viewed-videos-in-week`,
  MOSTLY_VIEWED: `${API_BASE}/lessons/top-videos`,
  USER_LAST_VIEWED: `${API_BASE}/lesson-videos/logs/user-last-viewed-video`,
  LIKE: `${API_BASE}/like`,
  BOOKMARK: `${API_BASE}/Bookmark`,
};
